import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { ADVERTISER_DOMAIN_REPORT_ID } from './advertiserDomainName';

const emptyColumns = [FIELDS.ADVERTISER_DOMAIN_NAME].map(createFooterMapper(ADVERTISER_DOMAIN_REPORT_ID));

const advertiserDomainReportFooterColumnDefinition = [...emptyColumns];

export default advertiserDomainReportFooterColumnDefinition;
